import type { JSX } from "solid-js";

/**
 * Figma modal (B1, B3, P1, E4): 354 px card, 24 px radius, lilac 140 px header, over a 50 % scrim.
 * Title and text use the `modal-title` / `modal-text` shortcuts.
 */
export function Modal(props: {
  header: JSX.Element;
  onClose: () => void;
  children: JSX.Element;
  label: string;
  /** Taller header (E2's mini-map: 196 px), with the close X on a white disc over it. */
  mapHeader?: boolean;
}) {
  return (
    <div
      class="fixed inset-0 z-40 bg-black/50 flex items-center justify-center px-6"
      role="dialog"
      aria-modal="true"
      aria-label={props.label}
    >
      <div class="w-full max-w-[354px] rounded-[24px] bg-white overflow-hidden shadow-[0_12px_32px_rgba(13,5,38,0.3)]">
        <div
          class={`relative bg-surface2 flex items-center justify-center ${props.mapHeader ? "h-[196px]" : "h-[140px]"}`}
        >
          {props.header}
          <button
            type="button"
            class="absolute right-[2px] top-[4px] h-11 w-11 flex items-center justify-center"
            onClick={props.onClose}
            aria-label="Fermer"
          >
            {props.mapHeader ? (
              <span class="flex h-8 w-8 items-center justify-center rounded-full bg-white shadow-[0_1px_3px_rgba(0,0,0,0.18)]">
                <img src="/icons/close.svg" width="20" height="20" alt="" />
              </span>
            ) : (
              <img src="/icons/close.svg" width="24" height="24" alt="" />
            )}
          </button>
        </div>
        <div class="px-4 pt-5 pb-7 text-center">{props.children}</div>
      </div>
    </div>
  );
}
